// extracted by mini-css-extract-plugin
export default {"preferences__switch":"styles_preferences__switch__m6fwj","preferences__list":"styles_preferences__list__rojmC","preferences__item":"styles_preferences__item__mxDkG"};